var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import MuiButton from '@mui/material/Button';
import { useTheme } from '@mui/material';
import { RakutenIcon } from '@next-common/material-ui-icons';
import Box from '@mui/material/Box';
import { CircularIndeterminateCustom } from '../Progress';
import { colorPalette } from '../../colorPalette';
export const Button = React.forwardRef((_a, ref) => {
    var { startIcon, endIcon, children, dataQa, isLoading, color, variant, onClick, onSubmit, onReset } = _a, otherProps = __rest(_a, ["startIcon", "endIcon", "children", "dataQa", "isLoading", "color", "variant", "onClick", "onSubmit", "onReset"]);
    const theme = useTheme();
    const setColorLoader = () => {
        if (variant === 'contained')
            return colorPalette.white;
        else
            switch (color) {
                case 'primary':
                    return theme.palette.primary.main;
                case 'secondary':
                    return theme.palette.secondary.main;
                case 'tertiary':
                    return theme.palette.tertiary.main;
                case 'info':
                    return theme.palette.info.main;
                default:
                    return theme.palette.primary.main;
            }
    };
    return (React.createElement(MuiButton, Object.assign({ ref: ref, startIcon: !isLoading && (typeof startIcon === 'string' ? React.createElement(RakutenIcon, { icon: startIcon }) : startIcon), endIcon: !isLoading && (typeof endIcon === 'string' ? React.createElement(RakutenIcon, { icon: endIcon }) : endIcon), "data-qa": dataQa ? dataQa : 'button-core', "data-role": "none", color: color, variant: variant, onClick: !isLoading ? onClick : undefined, onSubmit: !isLoading ? onSubmit : undefined, onReset: !isLoading ? onReset : undefined }, otherProps), isLoading ? (React.createElement(Box, { sx: {
            span: {
                height: `20px !important`,
                width: `20px !important`,
            },
        } },
        React.createElement(CircularIndeterminateCustom, { color: setColorLoader(), dataQa: `${dataQa}-loader` }))) : (children)));
});
